(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aaa-contact-page"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.documentElement.classList.remove('no-js');

    function toggleQ(btn){
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
    }

    function bindToggles(root){
      root.querySelectorAll('[data-q-toggle]').forEach(function(btn){
        btn.addEventListener('click', function(){ toggleQ(btn); });
      });
    }

    function openHash(root){
      var h = (location.hash || '').replace(/^#/, '');
      if (!h) return;
      var panel = root.querySelector('#' + CSS.escape(h));
      if (!panel) return;
      var btnId = h + '-btn';
      var btn = root.querySelector('#' + CSS.escape(btnId));
      if (btn && btn.getAttribute('aria-expanded') === 'false'){
        btn.setAttribute('aria-expanded', 'true');
        btn.scrollIntoView({behavior: 'smooth', block: 'start'});
      }
    }

    function bindForm(root){
      var f = root.querySelector('form.cnt-form');
      if (!f) return;
      var topic = f.querySelector('#contact_topic');
      var subject = f.querySelector('#contact_subject');
      var prefix = (root.getAttribute('data-subject-prefix') || 'Contact form').trim();

      function syncSubject(){
        if (!topic || !subject) return;
        var opt = topic.options[topic.selectedIndex];
        if (opt && opt.value){
          subject.value = prefix + ': ' + opt.text;
        }
      }
      if (topic) topic.addEventListener('change', syncSubject);

      f.addEventListener('submit', function(){
        syncSubject();
        try { sessionStorage.setItem('aaaContactTopic', (topic && topic.value) || ''); } catch (err) {} // read by aaa-lead-event on the success reload
        var b = f.querySelector('[data-submit]');
        if (!b) return;
        b.setAttribute('disabled', 'disabled');
        var lbl = b.querySelector('[data-submit-label]');
        if (lbl) lbl.textContent = 'Sending...';
      });
    }

    function init(root){
      bindToggles(root);
      bindForm(root);
      openHash(root);
    }

    // Run on every instance of the section
    document.querySelectorAll('[data-cnt]').forEach(init);
    window.addEventListener('hashchange', function(){
      document.querySelectorAll('[data-cnt]').forEach(openHash);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
